
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.475.35H3.004A1.236 1.236 0 001.75 1.564v10.91a1.236 1.236 0 001.254 1.215h8.471a1.236 1.236 0 001.254-1.215V1.564A1.236 1.236 0 0011.475.35zm-7 .841h2.052v2.536l-.017.056a.092.092 0 01-.116.012l-.659-.517a.379.379 0 00-.465 0l-.658.509-.094.009a.076.076 0 01-.043-.066zm7.41 11.187a.489.489 0 01-.5.48H3.003a.488.488 0 01-.5-.48V1.671a.488.488 0 01.5-.48h.714V3.73a.839.839 0 00.47.745.824.824 0 00.365.087h.011a.835.835 0 00.514-.177l.424-.328.424.333a.832.832 0 00.52.183.771.771 0 00.1-.006.84.84 0 00.744-.839V1.192h4.1a.489.489 0 01.5.48z"}})])
          )
        }
      }
    